import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  claims: [],
  claimsStatus: IDLE,
  claimsPerPage: 0,
  totalClaims: 0,

  exportClaimsStatus: IDLE,

  mapRisks: [],
  mapRisksStatus: IDLE,
  mapRisksCount: 0,
  mapClustersLoading: false,
  mapSelectedRiskId: null,
  mapSelectedRisk: null,
  mapSelectedRiskStatus: IDLE,
  mapSelectedRiskClaims: [],
  mapSelectedRiskClaimsStatus: IDLE,

  lastVisitedClaimId: null,

  policyDetailsClaims: [],
  policyDetailsClaimsStatus: IDLE,

  riskDetailsClaims: null,
  riskDetailsClaimsStatus: IDLE,

  claimsByDateAndLocation: [],
  claimsByDateAndLocationStatus: IDLE
};

const claimsSlice = createSlice({
  name: 'claims',
  initialState,
  reducers: {
    getClaims(state) {
      state.claimsStatus = LOADING;
    },
    getClaimsSucceeded(state, action) {
      state.claims = action.payload.claims;
      state.claimsPerPage = parseInt(action.payload.meta?.perPage, 10);
      state.totalClaims = parseInt(action.payload.meta?.total, 10);
      state.claimsStatus = SUCCEEDED;
    },
    getClaimsFailed(state) {
      state.claimsStatus = FAILED;
    },
    clearClaims(state) {
      state.claims = [];
      state.claimsPerPage = 0;
      state.totalClaims = 0;
    },

    exportClaims(state) {
      state.exportClaimsStatus = LOADING;
    },
    exportClaimsSucceeded(state) {
      state.exportClaimsStatus = SUCCEEDED;
    },
    exportClaimsFailed(state) {
      state.exportClaimsStatus = FAILED;
    },

    getMapRisks(state) {
      state.mapRisksStatus = LOADING;
    },
    getMapRisksSucceeded(state, action) {
      state.mapRisks = action.payload;
      state.mapRisksCount = action.payload.reduce((sum, { number_of_claims }) => sum + number_of_claims, 0);
      state.mapRisksStatus = SUCCEEDED;
    },
    getMapRisksFailed(state) {
      state.mapRisksStatus = FAILED;
    },

    setMapSelectedRiskId(state, action) {
      state.mapSelectedRiskId = action.payload;
    },
    getMapSelectedRisk(state) {
      state.mapSelectedRiskStatus = LOADING;
    },
    getMapSelectedRiskSucceeded(state, action) {
      state.mapSelectedRisk = action.payload;
      state.mapSelectedRiskStatus = SUCCEEDED;
    },
    getMapSelectedRiskFailed(state) {
      state.mapSelectedRiskStatus = FAILED;
    },

    getMapSelectedRiskClaims(state) {
      state.mapSelectedRiskClaimsStatus = LOADING;
    },
    getMapSelectedRiskClaimsSucceeded(state, action) {
      state.mapSelectedRiskClaims = action.payload;
      state.mapSelectedRiskClaimsStatus = SUCCEEDED;
    },
    getMapSelectedRiskClaimsFailed(state) {
      state.mapSelectedRiskClaimsStatus = FAILED;
    },

    setMapClustersLoading(state, action) {
      state.mapClustersLoading = action.payload;
    },

    setLastVisitedClaimId(state, action) {
      state.lastVisitedClaimId = action.payload;
    },
    resetLastVisitedClaimId(state) {
      state.lastVisitedClaimId = null;
    },

    getPolicyDetailsClaims(state) {
      state.policyDetailsClaimsStatus = LOADING;
    },
    getPolicyDetailsClaimsSucceeded(state, action) {
      state.policyDetailsClaims = action.payload;
      state.policyDetailsClaimsStatus = SUCCEEDED;
    },
    getPolicyDetailsClaimsFailed(state) {
      state.policyDetailsClaimsStatus = FAILED;
    },

    getRiskDetailsClaims(state) {
      state.riskDetailsClaimsStatus = LOADING;
    },
    getRiskDetailsClaimsSucceeded(state, action) {
      state.riskDetailsClaims = action.payload;
      state.riskDetailsClaimsStatus = SUCCEEDED;
    },
    getRiskDetailsClaimsFailed(state) {
      state.riskDetailsClaimsStatus = FAILED;
    },
    clearRiskDetailsClaims(state) {
      state.riskDetailsClaims = null;
      state.riskDetailsClaimsStatus = IDLE;
    },

    getClaimsByDateAndLocation(state) {
      state.claimsByDateAndLocationStatus = LOADING;
    },
    getClaimsByDateAndLocationSucceeded(state, action) {
      state.claimsByDateAndLocation = action.payload;
      state.claimsByDateAndLocationStatus = SUCCEEDED;
    },
    getClaimsByDateAndLocationFailed(state) {
      state.claimsByDateAndLocationStatus = FAILED;
    },
    clearClaimsByDateAndLocation(state) {
      state.claimsByDateAndLocation = [];
      state.claimsByDateAndLocationStatus = IDLE;
    }
  }
});

export const {
  getClaims,
  getClaimsSucceeded,
  getClaimsFailed,
  clearClaims,
  exportClaims,
  exportClaimsSucceeded,
  exportClaimsFailed,
  getMapRisks,
  getMapRisksSucceeded,
  getMapRisksFailed,
  setMapSelectedRiskId,
  getMapSelectedRisk,
  getMapSelectedRiskSucceeded,
  getMapSelectedRiskFailed,
  getMapSelectedRiskClaims,
  getMapSelectedRiskClaimsSucceeded,
  getMapSelectedRiskClaimsFailed,
  setMapClustersLoading,
  setLastVisitedClaimId,
  resetLastVisitedClaimId,
  getPolicyDetailsClaims,
  getPolicyDetailsClaimsSucceeded,
  getPolicyDetailsClaimsFailed,
  getRiskDetailsClaims,
  getRiskDetailsClaimsSucceeded,
  getRiskDetailsClaimsFailed,
  clearRiskDetailsClaims,
  getClaimsByDateAndLocation,
  getClaimsByDateAndLocationSucceeded,
  getClaimsByDateAndLocationFailed,
  clearClaimsByDateAndLocation
} = claimsSlice.actions;

export default claimsSlice.reducer;
